// extracted by mini-css-extract-plugin
export default {"frameWork":"index_frameWork_mkv84","framePic":"index_framePic_GguVa","members":"index_members_BnCBt"};